import { Divider, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetProductQuery } from "src/api/services/productsApi";
import { MatchParam } from "src/constants/matches";

const ProductDetails = () => {
  const { productId } = useParams<MatchParam<"PRODUCT_ID">>();
  const { data: product } = useGetProductQuery(productId ?? skipToken);

  const productInfo = useMemo(() => {
    if (product == null) return "";
    return `Product: ${product.name}`;
  }, [product]);

  if (product == null) {
    return null;
  }

  return (
    <Stack width="100%" gap={2}>
      <Stack direction="row" gap={2}>
        <Typography variant="h4">{productInfo}</Typography>
      </Stack>
      <Divider sx={{ backgroundColor: "#000000" }} />
    </Stack>
  );
};

export default ProductDetails;
